import { useMemo } from "react";

function toLowRegisterDecimal(num: number, decimals = 12): string {
  if (!isFinite(num)) return "0";
  if (num === 0) return "0";
  // Use toFixed with enough decimals, then trim trailing zeros
  let str = num.toFixed(decimals + 6); // extra to avoid rounding issues
  // Remove trailing zeros, but keep at least `decimals` digits after the decimal
  str = str.replace(/(\.[0-9]*[1-9])0+$/, "$1"); // remove trailing zeros after decimal
  // Remove trailing dot if integer
  if (str.endsWith('.')) str = str.slice(0, -1);
  // Remove scientific notation if present
  if (str.includes('e')) {
    str = num.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: decimals + 6 });
  }
  // Ensure at least one zero after decimal if number is very small
  if (str.startsWith(".")) str = "0" + str;
  return str;
}

export function useLowRegisterDecimal(value: number | string | undefined, decimals = 12): string {
  return useMemo(() => {
    if (value === undefined || value === null) return "0";
    const num = typeof value === "number" ? value : Number(value);
    if (isNaN(num)) return "0";
    return toLowRegisterDecimal(num, decimals);
  }, [value, decimals]);
}
